module.exports = __webpack_public_path__ + "img/cover-pic.e3d13c5f.png";